<template>
    <UserForm :url="url" :user="user" :errors="errors" :profile="false" v-on:save="saveUser"></UserForm>
</template>

<script>
import UserForm from '../user/UserForm'
export default {
  name: 'Profile',
  components: {UserForm},
  data () {
    return {
      user: {
        shipping: {},
        billing: {},
        roles: []
      },
      errors: {},
      apiUrl: '',
      url: ''
    }
  },
  watch: {
    user: {
      handler (val) {
        this.$store.commit('loading/changeUnsaved', true)
      },
      deep: true
    }
  },
  methods: {
    saveUser () {
      let self = this

      this.$http
        .put(this.url + `/profile/update`, this.user, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            self.user = res.data.data
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Profile'))
    this.$emit('updateDisable', true)

    let ep = JSON.parse(localStorage.getItem('endpoints'))

    if (ep.services['menu']) {
      this.apiUrl = ep.services['menu'] + '/' + process.env.API_ENDPOINT + '/admin'
    } else {
      this.apiUrl = process.env.API_URL + '/' + process.env.API_ENDPOINT + '/admin'
    }

    this.url = this.apiUrl

    let self = this
    this.$http
      .get(this.url + `/profile`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.user = res.data.data

        if (self.user.shipping == null) {
          self.user.shipping = {}
        }
        if (self.user.billing == null) {
          self.user.billing = {}
        }

        if (self.user.roles == null) {
          self.user.roles = []
        } else {
          for (let it in self.user.roles) {
            self.user.roles[it] = self.user.roles[it]._id
          }
        }
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/profile/Profile.vue